// pdfmake bootstrap with Sarabun (Thai) fonts.
// Loads Sarabun-Regular / Sarabun-Bold from src/assets/fonts at runtime,
// converts them to base64, and registers them in pdfmake's VFS.
// Cached: fonts are fetched once per page load.

/* eslint-disable @typescript-eslint/no-var-requires */
const pdfMake: any = require('pdfmake/build/pdfmake')
const pdfFonts: any = require('pdfmake/build/vfs_fonts')

const sarabunRegularUrl: string = require('assets/fonts/Sarabun/Sarabun-Regular.ttf').default
    || require('assets/fonts/Sarabun/Sarabun-Regular.ttf')
const sarabunBoldUrl: string = require('assets/fonts/Sarabun/Sarabun-Bold.ttf').default
    || require('assets/fonts/Sarabun/Sarabun-Bold.ttf')

let readyPromise: Promise<any> | null = null

async function fetchAsBase64(url: string): Promise<string> {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`Failed to load font ${url}: ${res.status}`)
    const buf = await res.arrayBuffer()
    const bytes = new Uint8Array(buf)
    let binary = ''
    const chunkSize = 0x8000
    for (let i = 0; i < bytes.length; i += chunkSize) {
        binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunkSize)))
    }
    return btoa(binary)
}

export function getPdfMake(): Promise<any> {
    if (readyPromise) return readyPromise
    readyPromise = (async () => {
        const [regularB64, boldB64] = await Promise.all([
            fetchAsBase64(sarabunRegularUrl),
            fetchAsBase64(sarabunBoldUrl),
        ])
        const baseVfs = (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) || pdfFonts.vfs || {}
        pdfMake.vfs = {
            ...baseVfs,
            'Sarabun-Regular.ttf': regularB64,
            'Sarabun-Bold.ttf': boldB64,
        }
        pdfMake.fonts = {
            ...(pdfMake.fonts || {}),
            Sarabun: {
                normal: 'Sarabun-Regular.ttf',
                bold: 'Sarabun-Bold.ttf',
                italics: 'Sarabun-Regular.ttf',
                bolditalics: 'Sarabun-Bold.ttf',
            },
        }
        return pdfMake
    })()
    return readyPromise
}
